import { render, staticRenderFns } from "./ExerciseLevel.vue?vue&type=template&id=75a7471c&"
import script from "./ExerciseLevel.vue?vue&type=script&lang=js&"
export * from "./ExerciseLevel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports